import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import '../../assets/vendor/css/pages/page-auth.css';
import './css/app.css';
import 'react-phone-input-2/lib/style.css'

import { ProfileProvider } from '../Contexts/ProfileContext';
import { useTitle } from '../../config/global';
import Layout from '../Layout/Layout';
import Account from './components/Account';
import Billing from './components/Billing';
import EmergencySettings from '../SharedComponents/Emergency/EmergencySettings';
import { useNavHub } from '../../nav/useInHub';
import SubTabs from '../../nav/SubTabs';

const menuTabDefs = [
    {
        key: "account",
        icon: <i className="bx bx-user me-1"></i>,
        component: <Account />
    },
    {
        key: "billing",
        icon: <i className="fa-solid fa-box me-1"></i>,
        component: <Billing />
    },
    {
        key: "emergency",
        icon: <i className="pi pi-bell me-1"></i>,
        component: <EmergencySettings />
    }
]

function Profile() {
    const { t } = useTranslation();
  const navV6 = useNavHub().navV6;
    useTitle("Profile");
    const location = useLocation();
    const [activeTab, setActiveTab] = useState(menuTabDefs[1])

    useEffect(() => {
        if (location.state?.activeTab) {
            const selectedTab = menuTabDefs.find(tab => tab.key === location.state.activeTab);
            if (selectedTab) {
                setActiveTab(selectedTab);
            }
        }
    }, [location.state?.activeTab]);

    const tabLabels = {
        account: t('profile.tab_account'),
        billing: t('profile.tab_billing'),
        emergency: t('profile.tab_emergency'),
    };

    return (
        <Layout>
            <ProfileProvider>
                <div className="content-wrapper">
                    {/* Content */}
                    <div className="mx-md-2 flex-grow-1  ">
                        <div className="row">
                            <div className="col-md-12">
                                {navV6 ? (
                                    <SubTabs ariaLabel={t('profile.tab_billing')} items={menuTabDefs.map((tab) => ({
                                        id: tab.key, label: tabLabels[tab.key], active: activeTab.key === tab.key,
                                        onClick: () => setActiveTab({ key: tab.key, component: tab.component }),
                                    }))} />
                                ) : (
                                <ul className="nav nav-pills flex-column flex-md-row mb-3">
                                    {
                                        menuTabDefs.map((tab, index) => {
                                            return (
                                                <li className="nav-item me-2"
                                                    onClick={() => {
                                                        setActiveTab({
                                                            key: tab.key,
                                                            component: tab.component
                                                        })
                                                    }}
                                                    key={`tab-${tab.key}`}>
                                                    <a
                                                        className={`nav-link ${activeTab.key == tab.key ? "active" : "bg-secona"}`}
                                                        href="#"
                                                        onClick={(e) => e.preventDefault()}
                                                    >
                                                        {tab.icon} {tabLabels[tab.key]}
                                                    </a>
                                                </li>
                                            )
                                        })
                                    }
                                </ul>
                                )}
                            </div>
                            <div div className="col-md-12">
                                {activeTab.component}
                            </div>
                        </div>
                    </div>

                    <div className="content-backdrop fade" />
                </div>
            </ProfileProvider>
        </Layout>
    );
}

export default Profile